import { Link } from 'react-router-dom';

export default function AboutSection() {
  return (
    <section id="about" className="py-16 md:py-24 bg-secondary-50">
      <div className="w-full px-4 md:px-6 max-w-6xl mx-auto">
        <div className="flex flex-col lg:flex-row items-start gap-10 lg:gap-16">
          <div className="flex-1">
            <p className="text-xs md:text-sm text-foreground-500 tracking-wider mb-4 whitespace-nowrap">
              / About OOPBuy
            </p>
            <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-950 mb-6 leading-snug">
              What is OOPBuy Spreadsheet?
            </h2>
            <div className="space-y-4 text-sm md:text-base text-foreground-700 leading-relaxed">
              <p>
                OOPBuy Spreadsheet is a structured shopping management system designed to help users track, compare, and manage product orders efficiently. Instead of manually handling product links and fragmented orders across multiple platforms, users can leverage a centralized spreadsheet-based system that brings everything together in one organized view.
              </p>
              <p>
                The system enables shoppers to organize product listings from diverse categories — from fashion and accessories to everyday essentials — all within a single, easy-to-navigate interface. By replacing scattered bookmarks and messy spreadsheets with a purpose-built solution, OOPBuy Spreadsheet transforms how modern shoppers approach bulk purchasing and product discovery.
              </p>
              <p>
                This approach is widely adopted in modern agent shopping workflows, where speed, accuracy, and clear data organization directly impact the quality of purchasing decisions. Whether you are a casual shopper exploring new categories or a power user managing dozens of orders simultaneously, the OOPBuy Spreadsheet system adapts to your needs.
              </p>
            </div>

            <div className="mt-8 flex items-center gap-4">
              <div className="flex -space-x-2">
                {[1, 2, 3, 4].map((i) => (
                  <div key={i} className="w-9 h-9 rounded-full bg-foreground-700 flex items-center justify-center text-background-50 text-xs font-bold border-2 border-secondary-50">
                    <i className="ri-user-line"></i>
                  </div>
                ))}
              </div>
              <p className="text-sm text-foreground-600 whitespace-nowrap">
                <strong className="text-foreground-900">Join the smart shopping community</strong>
              </p>
            </div>

            <div className="mt-6">
              <Link
                to="/article/oopbuy-spreadsheet-complete-guide"
                className="inline-flex items-center gap-2 text-sm font-medium text-primary-500 hover:text-primary-600 transition-colors cursor-pointer whitespace-nowrap"
              >
                Read the full guide
                <i className="ri-arrow-right-line"></i>
              </Link>
            </div>
          </div>

          <div className="flex-1">
            <div className="bg-background-50 rounded-2xl p-6 md:p-8">
              <div className="grid grid-cols-2 gap-4">
                {[
                  { icon: 'ri-file-list-3-line', title: 'Organize Listings', desc: 'Structure all your product links and details in one place' },
                  { icon: 'ri-scales-3-line', title: 'Compare Prices', desc: 'Evaluate multiple sellers side by side instantly' },
                  { icon: 'ri-truck-line', title: 'Track Orders', desc: 'Monitor shipping progress with real-time updates' },
                  { icon: 'ri-shield-check-line', title: 'Reduce Mistakes', desc: 'Minimize ordering errors with validated data' },
                ].map((item) => (
                  <div key={item.title} className="text-center p-4">
                    <div className="w-12 h-12 mx-auto mb-3 flex items-center justify-center rounded-full bg-accent-100">
                      <i className={`${item.icon} text-lg text-accent-600`}></i>
                    </div>
                    <h4 className="text-sm font-semibold text-foreground-900 mb-1 whitespace-nowrap">{item.title}</h4>
                    <p className="text-xs text-foreground-500 leading-relaxed">{item.desc}</p>
                  </div>
                ))}
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}